import MultiSelect from "designSystem/components/select/MultiSelect";
import { Grid } from "designSystem/index";
import { itemsInChinese } from "designSystemLegacy/data";
import React from "react";

export default () => {
	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<MultiSelect
					allowPinyin
					options={itemsInChinese}
					value={[itemsInChinese[0]]}
				/>
			</Grid>
		</Grid>
	);
};